export default Object.freeze([
  "BOOK",
  "BOOK_PACKAGE",
  "CHAPTER",
  "COMPETENCE_MODULE",
  "SCHOOL_SUBJECT",
  "SCHOOL_TYPE",
  "SKILL",
  "TASK",
  "TASK_TYPE",
  "TOPIC",
  "FILTER",
  "CONTENT_TYPE"
]);
